import { Box } from "@mui/material";
import { sectionBox } from "../styles/ComponentStyles";
import { useTranslate } from "../components/Translate/TranslateContext";
import AnimatedIcons from "../components/Layout/AnimatedIcons";
import { useLogin } from "../hooks/useLogin";

import AccountCard from "../components/Layout/AccountCard";
import LoginForm from "../components/Login/LoginForm";
import ResetPasswordForm from "../components/Login/ResetPasswordForm";

export default function Login({ onLoginSuccess }) {
  const { translate, language } = useTranslate();

  const login = useLogin({
    onLoginSuccess,
    translate,
    language,
  });

  return (
    <Box>
      <AccountCard edge="left" title={translate("HarvestHub")}>
        {!login.resetMode ? (
          <LoginForm
            translate={translate}
            {...login}
            onSubmit={login.handleSubmit}
            onForgot={() => login.setResetMode(true)}
          />
        ) : (
          <ResetPasswordForm
            translate={translate}
            {...login}
            onSubmit={login.handleReset}  
            onBack={() => login.setResetMode(false)}
          />
        )}
      </AccountCard>
    </Box>
  );
}

